<div *ngFor="let item of termsOfUse">
  
  <div [innerHTML]="item.body"></div>
</div>